export default {
    wechatConfig: '/v1/common/wechatsharecfg',
    thirdLogin: '/v1/wechat/getuserinfo',
    getInfo: '/v1/user/getmyinfo',
    wechath5login: '/v1/user/wechath5login',
    getUploadTokenUrl: '/v1/common/uploadtoken',
};